import { useMemo } from "react";

import { useTrack } from "pro-features/components/WithTrack/src/useTrack";

import createScoringBoardTrackingService from "../services/tracking/scoring-board-factory";

export const useScoringBoardTrackingService = () => {
    const [track] = useTrack();

    return useMemo(() => createScoringBoardTrackingService(track), [track]);
};
